import Request from "../model/Request";
import Response from "../model/Response";
import {Config} from "../util/Config";
import { RestClient } from "../util/RestClient";
import AgencyBillingClosureResponse from "../model/billingPeriod/AgencyBillingClosureResponse";

export module AgencyBillingClosureService {
    export async function getByBillingPeriodId(billingPeriodId: string): Promise<Response<AgencyBillingClosureResponse[]>> {
        const url = Config.get("GET_AGENCY_BILLING_CLOSURE_URL", { id: billingPeriodId });
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const billingPeriodsData = response.data;
            if (billingPeriodsData) {
                const data = billingPeriodsData.map((t: any) => new AgencyBillingClosureResponse(
                    t.id,
                    t.billingPeriodId,
                    t.agencyId,
                    t.agencyName,
                    t.closureDate,
                    t.closedBy,
                    t.totalAmount,
                    t.notes,
                ));
                return new Response<AgencyBillingClosureResponse[]>(true, data, response.error)
            }
        }
        return new Response<AgencyBillingClosureResponse[]>(false, undefined, response.error, response.status);
    }

    export async function update(id: string, totalAmount: number, notes: string): Promise<Response<any>> {
        const url = Config.get("UPDATE_AGENCY_BILLING_CLOSURE_URL", {id: id});
        const request = new Request(url, {
            totalAmount,
            notes
        });
        return await RestClient.put(request);
    }

}